/****************************************************
 * Module Name:  mixSizeProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class MixSizeProxy {
  static GetAllSize = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/size",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllSizeMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/size/mini",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleSize = (sizeId, callback) => {
    let params = {
      id: sizeId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/size",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckSizeAvailable = (size, callback) => {
    let params = {
      size: size,
    };

    restAPICall(
      Constants.MANAGER_URL + "/mix/size/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddSize = (size, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/size",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(size),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateSize = (size, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/size",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(size),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteSize = (size, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/mix/size",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(size),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
